import { RemovableTag } from '@monash/portal-react';
import cs from '../shared.module.scss';

const StatusFiltersTags = ({ options, selectedValues, onRemove }) => {
  return options
    .filter((opt) => selectedValues?.includes(opt.value))
    .map((opt) => (
      <RemovableTag
        key={opt.value}
        className={cs.tag}
        text={opt.text}
        size="large"
        onRemove={() => onRemove(opt.value)}
      />
    ));
};

export default StatusFiltersTags;
